/** @jsx jsx */

import type { HTMLAttributes } from 'react';
import { jsx } from '@balance-web/core';

/** Hide with opacity so elements maintain their dimensions and the button doesn't change shape. */
export const HiddenWhenLoading = ({
  isLoading,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { isLoading: boolean }) => {
  return <span css={isLoading ? { opacity: 0 } : null} {...props} />;
};
